// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3JNYr","modalFooterButton":"ModalNotes_modalFooterButton__12Iai"};